import { format } from "date-fns";
import useSWR, { SWRResponse } from "swr";
import { IFundPriceHistoryResponse, IUseFundPriceHistory, IFundPriceHistoryOptions } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "@portal/hooks/common/commonFetcher";
import { IFundPriceHistory } from "@portal/types/api/IFundPriceHistory";

const useFundPriceHistory: IUseFundPriceHistory = (opts: IFundPriceHistoryOptions) => {
  const { update } = useSession();

  const fetcher = async (url: URL): Promise<IFundPriceHistoryResponse> => {
    const json = await commonFetcher<IFundPriceHistory[]>(url);
    return { fundPriceHistoryList: json };
  };

  if (!opts.isin) {
    throw new Error("Isin is required in useFundPriceHistory.");
  }

  const date = !opts.fromDate ? new Date(new Date().setFullYear(new Date().getFullYear() - 5)) : new Date(opts.fromDate);
  const response: SWRResponse<IFundPriceHistoryResponse, unknown> = useSWR(
    `/api/fund-price-history/${opts.isin}?dateFrom=${format(date, "yyyy-MM-dd")}&period=D`,
    fetcher,
    commonSwrConfig(update),
  );

  return {
    fundPriceHistoryList: response.data?.fundPriceHistoryList,
    error: response.error,
    isLoading: !response.data && !response.error,
  };
};

export default useFundPriceHistory;
